import React from "react";
import {
  Box,
  VStack,
  Heading,
  HStack,
  Input,
  Button,
  useToast,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import resumeRepositoryService from "../services/resumeRepositoryService";
import { RESUME_QUERY_KEYS } from "../hooks/useResumeSearch";
import MatchResultTable from "../components/MatchResultTable";

const JobMatchPage = () => {
  const { jobId } = useParams();
  const toast = useToast();
  const [top, setTop] = React.useState(25);
  const [topInput, setTopInput] = React.useState("25");

  const { data, refetch, isFetching } = useQuery({
    queryKey: [RESUME_QUERY_KEYS.match, jobId, top],
    queryFn: () => resumeRepositoryService.matchByJob(jobId, { top }),
    enabled: Boolean(jobId),
  });

  const handleRefresh = async () => {
    const nextTop = Math.max(1, Number(topInput) || 25);
    setTop(nextTop);
    try {
      await refetch();
    } catch (error) {
      toast({
        title: "Failed to refresh matches",
        status: "error",
        duration: 2500,
      });
    }
  };

  return (
    <Box p={6}>
      <VStack align="stretch" spacing={4}>
        <Heading size="md">Job Match Results</Heading>
        <HStack>
          <Input
            value={topInput}
            onChange={(e) => setTopInput(e.target.value)}
            type="number"
            width="180px"
            min={1}
            max={200}
          />
          <Button onClick={handleRefresh} isLoading={isFetching}>
            Refresh Matches
          </Button>
        </HStack>
        <MatchResultTable candidates={data?.data?.candidates || []} />
      </VStack>
    </Box>
  );
};

export default JobMatchPage;
